import React from 'react';
import { observer } from 'mobx-react';
import { Badge } from 'react-bootstrap';

import { WidgetRow } from 'src/libs/ui-kit/widget-row/WidgetRow';

import { widgetLabels } from '../constants';

import { useProfileWidgetStore } from './StoreProvider';

export const SocialNetworksRow = observer(() => {
  const { profile } = useProfileWidgetStore();
  return (
    <WidgetRow
      label={widgetLabels.socialNetworks}
      value={profile?.socialNetworks?.map(({ name, url }) => (
        <Badge as="a" variant="secondary" key={url} href={url!}>
          {name}
        </Badge>
      ))}
    />
  );
});
